export const META_CONFIG = {
  // Landing/Home
  'Landing': {
    title: 'Adventure Motorcycle Tours Worldwide',
    description: 'Join Renedian for epic motorcycle adventures across Africa, Canada, Mongolia, Europe and South America. Professional guides, premium support, unforgettable experiences.'
  },
  
  // Public Pages
  'Choose': {
    title: 'Why Choose Renedian?',
    description: 'Discover why riders choose Renedian for their motorcycle adventures. Expert guides, premium support vehicles, small groups, and 15+ years of experience.'
  },
  
  'Gear': {
    title: 'Motorcycle Gear & Equipment',
    description: 'Essential gear recommendations for your motorcycle adventure. Professional advice on equipment, clothing, and accessories for your tour.'
  },
  
  'Privacy': {
    title: 'Privacy Policy',
    description: 'Read Renedian\'s privacy policy to understand how we collect, use, and protect your personal information.'
  },
  
  'Rentals': {
    title: 'Motorcycle Rentals',
    description: 'Rent premium motorcycles for your adventure. Quality bikes, full insurance, and expert support for independent riders.'
  },
  
  'Tales': {
    title: 'Rider Tales & Stories',
    description: 'Read inspiring stories from past riders who have experienced the adventure of a lifetime with Renedian motorcycle tours.'
  },
  
  'Tours': {
    title: 'Adventure Motorcycle Tours',
    description: 'Browse all Renedian motorcycle tours across Africa, Canada, Mongolia, Europe and South America. Small groups, expert guides, premium support.'
  },
  
  'Booking': {
    title: 'Book Your Motorcycle Adventure',
    description: 'Book your motorcycle tour with Renedian. Easy online booking, secure payments, and personal service for your adventure of a lifetime.'
  },

  'BookingV2': {
    title: 'Book Your Motorcycle Adventure',
    description: 'Book your motorcycle tour with Renedian. Easy online booking, secure payments, and personal service for your adventure of a lifetime.'
  },

  'BookingV2WithId': {
    title: 'Book Your Motorcycle Adventure',
    description: 'Book your motorcycle tour with Renedian. Easy online booking, secure payments, and personal service for your adventure of a lifetime.'
  },
  
  // Tour-specific pages
  'CapeTownToVictoriaFalls': {
    title: 'Cape Town to Victoria Falls Motorcycle Tour',
    description: 'Epic 21-day motorcycle tour from Cape Town to Victoria Falls. Ride through South Africa, Namibia, Botswana and Zimbabwe on paved roads.'
  },
  
  'GobiDiscovery': {
    title: 'Gobi Discovery Motorcycle Tour Mongolia',
    description: 'Explore Mongolia\'s legendary Gobi Desert on this 15-day motorcycle adventure. Experience nomadic culture and vast wilderness.'
  },
  
  'GoldenEagleFestival': {
    title: 'Golden Eagle Festival Motorcycle Tour',
    description: 'Join the legendary Golden Eagle Festival in Mongolia. Witness ancient traditions and ride through spectacular landscapes.'
  },
  
  'JourneyToUshuaia': {
    title: 'Journey to Ushuaia Motorcycle Tour',
    description: 'Adventure to the end of the world on this South America motorcycle tour. Patagonia, glaciers, and the road to Ushuaia.'
  },
  
  'NorthToTheYukon': {
    title: 'North to the Yukon Motorcycle Tour',
    description: 'Ride to Canada\'s remote Yukon Territory. Adventure through British Columbia and beyond to Dawson City and the Arctic Circle.'
  },
  
  'SpectacularSouthWestAfrica': {
    title: 'Spectacular South West Africa Motorcycle Tour',
    description: 'Discover Namibia\'s stunning landscapes on this motorcycle tour from Windhoek to Cape Town. Deserts, mountains, and coastal beauty.'
  },
  
  'TheBestOfTheCanadianRockies9': {
    title: 'Canadian Rockies 9-Day Express Motorcycle Tour',
    description: 'Experience the best of the Canadian Rockies in 9 days. Mountain passes, alpine lakes, and stunning scenery in BC and Alberta.'
  },
  
  'TheBestOfTheCanadianRockies12': {
    title: 'Best of Canadian Rockies 12-Day Motorcycle Tour',
    description: 'The ultimate Canadian Rockies motorcycle experience. 12 days exploring the best roads in British Columbia and Alberta.'
  },
  
  'TheGrandTour': {
    title: 'The Grand Tour - Southern Africa Motorcycle Adventure',
    description: 'Experience the best of southern Africa on this comprehensive motorcycle tour. Wildlife, culture, and spectacular landscapes.'
  },
  
  'TwoOceans': {
    title: 'Two Oceans Cape Motorcycle Tour',
    description: 'Ride the spectacular Cape Peninsula between two oceans. Coastal roads, mountain passes, and South African hospitality.'
  },
  
  'VictoriaFallsToCapeTown': {
    title: 'Victoria Falls to Cape Town Motorcycle Tour',
    description: 'Journey from Victoria Falls to Cape Town on this epic motorcycle adventure through Botswana, Namibia and South Africa.'
  },
  
  'WaterfallsAndWildlife': {
    title: 'Waterfalls & Wildlife Motorcycle Tour',
    description: 'Experience Africa\'s wildlife and natural wonders on this motorcycle tour through Namibia, Botswana, and Zimbabwe.'
  }
}

// Helper function to get meta data for a route
export function getMetaForRoute(routeName, routeParams = {}) {
  const meta = META_CONFIG[routeName]
  if (!meta) {
    return {
      title: 'Renedian Motorcycle Tours',
      description: 'Adventure motorcycle tours worldwide with expert guides and premium support.'
    }
  }
  
  return {
    title: meta.title,
    description: meta.description
  }
} 